<div id="selector" >
    <bm-about-usabout-us  (pressed)="onPressed($event)" text="MISIÓN"></bm-about-usabout-us>
    <bm-about-usabout-us (pressed)="onPressed($event)"  text="VISIÓN"></bm-about-usabout-us>
    <bm-about-usabout-us (pressed)="onPressed($event)"  text="VALORES"></bm-about-usabout-us>
     

</div>